(() => {
  if (customElements.get('wallow-native')) return;
  customElements.define('wallow-native', class extends HTMLElement {
    connectedCallback() {
      const select = this.querySelector('[data-variant]');
      if (!select || this.dataset.ready) return;
      this.dataset.ready = 'true';
      const sizeOptions = [...this.querySelectorAll('[data-size-options] input')];
      const packOptions = [...this.querySelectorAll('[data-pack-options] input')];
      const update = () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        sizeOptions.find(input => input.value === option.dataset.size).checked = true;
        packOptions.find(input => input.value === option.dataset.pack).checked = true;
        this.querySelector('p[data-price]').textContent = option.dataset.price;
        const button = this.querySelector('[data-add]');
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? 'Sold out' : 'Get Wallow';
      };
      const deepLink = new URL(location.href).searchParams.get('variant');
      if ([...select.options].some(option => option.value === deepLink)) select.value = deepLink;
      if (deepLink) {
        const url = new URL(location.href);
        url.searchParams.delete('variant');
        history.replaceState({}, '', url);
      }
      const choose = () => {
        const size = sizeOptions.find(input => input.checked)?.value;
        const pack = packOptions.find(input => input.checked)?.value;
        const option = [...select.options].find(item => item.dataset.size === size && item.dataset.pack === pack);
        if (option) select.value = option.value;
        update();
      };
      [...sizeOptions, ...packOptions].forEach(input => input.addEventListener('change', choose));
      update();
      const slides = [...this.querySelectorAll('[data-gallery-slide]')];
      const thumbs = [...this.querySelectorAll('[data-gallery-thumb]')];
      let current = 0;
      const show = index => {
        if (!slides.length) return;
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== current; });
        thumbs.forEach((thumb, i) => { thumb.setAttribute('aria-pressed', String(i === current)); });
      };
      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
      this.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(current - 1));
      this.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(current + 1));
      show(0);
    }
  });
})();
